module.exports = __webpack_public_path__ + "img/harvest.5dafd354.svg";